/* Joe Luxe "The Index": list/grid toggle (remembered), quick find on loaded
   pieces (Enter searches the whole store), and "Show more" that appends the next
   page in place so the page stays light with hundreds of pieces. */
(function () {
  var root = document.querySelector('[data-jl-ix]');
  if (!root) return;
  var list = root.querySelector('[data-jl-ix-list]');
  var input = root.querySelector('[data-jl-ix-input]');
  var form = root.querySelector('[data-jl-ix-search]');
  var empty = root.querySelector('[data-jl-ix-empty]');
  var buttons = root.querySelectorAll('[data-jl-ix-view]');
  var KEY = 'jl-ix-view';

  function setView(v) {
    root.classList.toggle('is-grid', v === 'grid');
    Array.prototype.forEach.call(buttons, function (b) {
      var on = b.getAttribute('data-jl-ix-view') === v;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  if (saved === 'grid') setView('grid');
  Array.prototype.forEach.call(buttons, function (b) {
    b.addEventListener('click', function () { setView(b.getAttribute('data-jl-ix-view')); });
  });

  function filter() {
    var q = (input && input.value || '').trim().toLowerCase();
    var shown = 0;
    Array.prototype.forEach.call(list.children, function (row) {
      var hit = !q || (row.getAttribute('data-code') || '').indexOf(q) > -1 || (row.getAttribute('data-name') || '').indexOf(q) > -1;
      row.hidden = !hit;
      if (hit) shown++;
    });
    if (empty) empty.hidden = !(q && shown === 0);
    return shown;
  }
  if (input) input.addEventListener('input', filter);
  if (form) {
    form.addEventListener('submit', function (e) {
      var visible = Array.prototype.filter.call(list.children, function (r) { return !r.hidden; });
      if (input.value.trim() && visible.length === 1) {
        e.preventDefault();
        window.location.href = visible[0].querySelector('a').href;
      }
    });
  }

  root.addEventListener('click', function (e) {
    var more = e.target.closest('[data-jl-ix-more]');
    if (!more || more.classList.contains('is-loading')) return;
    e.preventDefault();
    more.classList.add('is-loading');
    fetch(more.href, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rows = doc.querySelectorAll('[data-jl-ix-list] > li');
        Array.prototype.forEach.call(rows, function (r) { list.appendChild(document.adoptNode(r)); });
        var next = doc.querySelector('[data-jl-ix-more]');
        if (next) {
          more.href = next.getAttribute('href');
          more.classList.remove('is-loading');
        } else {
          more.remove();
        }
        filter();
      })
      .catch(function () {
        window.location.href = more.href; /* fall back to the normal next page */
      });
  });
})();
